export default __webpack_public_path__ + "static/home-one-banner-shape-409fd3cd8160d0abf22ea548000d33ca.png";